import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=ab368e80"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=ab368e80&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab368e80')) {
      api.createRecord('ab368e80', component.options)
    } else {
      api.reload('ab368e80', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=ab368e80", function () {
      api.rerender('ab368e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Confirm.vue"
export default component.exports